import type { IFilterViewBaseProps } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/filterInstance";

import type FindIosDownloadAndEngagementFilter from "../../../../models/IosDownloadAndEngagementFilter/IosDownloadAndEngagementFilter";
import DownloadEngagementFilter from "../DownloadEngagementFilter";

const AppIosDownloadEngagementFilter = ({
    filter,
    value,
    onFilterUpdate,
}: IFilterViewBaseProps<FindIosDownloadAndEngagementFilter>) => {
    return (
        <DownloadEngagementFilter
            filter={filter}
            value={value}
            hasDeviceFilter
            onFilterUpdate={onFilterUpdate}
        />
    );
};

export default AppIosDownloadEngagementFilter;
